import React, { useState } from 'react'
import { img } from '../assets/assets'

const Ambassador = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    return (
        <>
            <div className="overflow-hidden">
                {/* <!-- <div className="bg-dark py-10">
            <div className="container">
                <div
                    className="text-center
                    d-flex
                    justify-content-between
                    space-x-10
                    align-items-center">
                    <div className="space-x-10 d-flex align-items-center">
                        <lottie-player
                            src="https://assets6.lottiefiles.com/private_files/lf30_kqshlcsx.json"
                            background="transparent"
                            speed="2"
                            style="width: 50px; height: 50px"
                            loop
                            autoplay></lottie-player>
                        <p className="color_white">
                            Dark mode is now
                            <span style="color: rgb(0, 255, 170)">Available </span>
                        </p>
                    </div>

                    <div className="mode_switcher space-x-10">
                        <a href="#" className="light d-flex align-items-center is_active">
                            <i className="ri-sun-fill"></i> Light
                        </a>
                        <a href="#" className="dark d-flex align-items-center">
                            <i className="ri-moon-fill"></i> Dark
                        </a>
                    </div>
                </div>
            </div>
        </div> --> */}

                <header className="header__1 js-header" id="header">
                    <div className="container">
                        <div className="wrap js-header-wrapper">
                            <div className="header__logo">
                                <a className="color_black" href="/">
                                    <img
                                        src={img.logos_seducetoken}
                                        alt="logo"
                                        id="logo_js_f"
                                    />
                                </a>
                            </div>

                            {/* <!-- ==================  --> */}
                            <div className="header__menu">
                                <ul className="d-flex space-x-20">
                                    <li className="has_popup">
                                        <a className="color_black" href="/">
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/about"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="color_black" href="/team">
                                            Our Team
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href={img.whitepaper}
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/ambassador"
                                        >
                                            Ambassadors
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/contact"
                                        >
                                            Contact
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {/* <!-- ================= --> */}
                            <div className="header__btns">
                                <a
                                    className="btn btn-grad btn-sm"
                                    href="/dashboard"
                                >
                                    <img
                                        src={img.icons_settings}
                                        alt="Dashboard"
                                        height="20px"
                                        width="20px"
                                    />
                                    Dashboard
                                </a>
                            </div>

                            <div
                                className="header__burger js-header-burger"
                                onClick={() =>
                                    setShowMobileMenu(!showMobileMenu)
                                }
                            ></div>
                            {showMobileMenu ? (
                                <div className="header__mobile js-header-mobile">
                                    <div className="header__mobile__menu space-y-40">
                                        <ul className="d-flex space-y-20">
                                            <li className="has_popup">
                                                <a
                                                    className="color_black"
                                                    href="/"
                                                >
                                                    Home
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/about"
                                                >
                                                    About Us
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/team"
                                                >
                                                    Our Team
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/roadmap"
                                                >
                                                    Roadmap
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href={img.whitepaper}
                                                >
                                                    Whitepaper
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/ambassador"
                                                >
                                                    Ambassadors
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/contact"
                                                >
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="space-y-20">
                                            <a
                                                className="btn btn-grad btn-sm"
                                                href="/dashboard"
                                            >
                                                Dashboard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </header>

                <div className="hero__creators">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-lg-6">
                                <div className="space-y-20">
                                    <h1>Ambassadors & Creators.</h1>
                                    {/* <!-- <p className="hero__text">
                                You can view all our prevailing ambassadors and creators here. Do you want to become an ambassador? <a href="dashboard.html">Contact</a> us.
                            </p> --> */}
                                </div>
                            </div>
                            {/* <div className="col-lg-auto">
                                <a className="btn btn-dark" href="/dashboard">
                                    Become an ambassador
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <a href="https://www.instagram.com/realshelbyparis/?hl=en">
                                            <img
                                                src={img.avatar_shelby_main}
                                                alt="Avatar"
                                                className="avatar avatar-md"
                                            />
                                        </a>
                                        <div className="has_number">1</div>
                                    </div>
                                    <div className="text-center">
                                        <a href="https://www.instagram.com/realshelbyparis/?hl=en">
                                            <p className="avatars_name large color_black">
                                                Shelby Paris
                                            </p>
                                            <img
                                                src={img.icons_instagram}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.avatar_cherrylovetv}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">2</div>
                                    </div>
                                    <div className="text-center">
                                        <a href="https://www.instagram.com/cherrylovetv">
                                            <p className="avatars_name large color_black">
                                                Cherry Love
                                            </p>
                                            <img
                                                src={img.icons_instagram}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                        <a href="https://linktr.ee/cherrylovetv">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_first}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">3</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Aokochan
                                        </p>
                                        <a href="https://onlyfans.com/aokotan">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_second}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">4</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Amy Karamel
                                        </p>
                                        <a href="https://onlyfans.com/amy_karamel">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_third}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">5</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Jenny Jen
                                        </p>
                                        <a href="https://onlyfans.com/missjennyjen">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <a href="https://www.instagram.com/anaztazyz/">
                                            <img
                                                src={img.ambassador_forth}
                                                alt="Avatar"
                                                className="avatar avatar-md"
                                            />
                                        </a>
                                        <div className="has_number">6</div>
                                    </div>
                                    <div className="text-center">
                                        <a href="https://www.instagram.com/anaztazyz/">
                                            <p className="avatars_name large color_black">
                                                Anastasy
                                            </p>
                                            <img
                                                src={img.icons_instagram}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                        <a href="https://onlyfans.com/anaztazyz">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_five}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />

                                        <div className="has_number">7</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Kay baby
                                        </p>
                                        <a href="https://onlyfans.com/bitesizedbabee">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <a href="https://www.instagram.com/salliespring1/">
                                            <img
                                                src={img.ambassador_six}
                                                alt="Avatar"
                                                className="avatar avatar-md"
                                            />
                                        </a>
                                        <div className="has_number">8</div>
                                    </div>
                                    <div className="text-center">
                                        <a href="https://www.instagram.com/salliespring1/">
                                            <p className="avatars_name large color_black">
                                                Sallie Spring
                                            </p>
                                            <img
                                                src={img.icons_instagram}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_seven}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />

                                        <div className="has_number">9</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Diana Heiss
                                        </p>
                                        <a href="https://onlyfans.com/dianaheissfree">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_nine}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">10</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Joyce Latina
                                        </p>
                                        <a href="https://onlyfans.com/chikalatina">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_ten}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">11</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Hunny Bunny
                                        </p>
                                        <a href="https://onlyfans.com/darkrabbithouse">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_eleven}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">12</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Amora Fierce
                                        </p>
                                        <a href="https://onlyfans.com/amorafierce">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twelve}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">13</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Shin No
                                        </p>
                                        <a href="https://onlyfans.com/shinno666olo">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_thirteen}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">14</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Rinchan
                                        </p>
                                        <a href="https://onlyfans.com/moechan">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_foureen}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">15</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Yuzu
                                        </p>
                                        <a href="https://onlyfans.com/bsyk9294">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_fifteen}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">16</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Mookie Gunso
                                        </p>
                                        <a href="https://onlyfans.com/lonely_gunso">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_sixteen}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">17</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Smurfblue Bubble
                                        </p>
                                        <a href="https://onlyfans.com/smurfblue_bubble">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_seventeen}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">18</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            NekomiiN
                                        </p>
                                        <a href="https://twitter.com/musickii04?s=09">
                                            <img
                                                src={img.icons_twitter}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_eighteen}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">19</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Babynitar
                                        </p>
                                        <a href="https://onlyfans.com/venitar">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_nineteen}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">20</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Soru Kisara
                                        </p>
                                        <a href="https://onlyfans.com/soru_kisara">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">21</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Buxny
                                        </p>
                                        <a href="https://onlyfans.com/showmebuxnybear">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty_one}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">22</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Anna
                                        </p>
                                        <a href="https://onlyfans.com/munchkin_anna">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty_two}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">23</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Queen Costh
                                        </p>
                                        <a href="https://twitter.com/Queen_costh?s=09">
                                            <img
                                                src={img.icons_twitter}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty_three}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">24</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Bo-Ar
                                        </p>
                                        <a href="https://onlyfans.com/bo-ar">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty_four}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">25</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Kadorin Cosplay
                                        </p>
                                        <a href="https://onlyfans.com/hitomicosplay">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty_five}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">26</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Anaki Rinrin
                                        </p>
                                        <a href="https://onlyfans.com/jknf6">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty_six}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">27</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Black Cinderella
                                        </p>
                                        <a href="https://onlyfans.com/black_cinderella">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.ambassador_twenty_seven}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">28</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Natti M
                                        </p>
                                        <a href="https://onlyfans.com/latinnnbabe">
                                            <img
                                                src={img.icons_onlyfans}
                                                alt=""
                                                width="30px"
                                                height="30px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <footer className="footer__1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 space-y-20">
                                <div className="footer__logo">
                                    <a href="/">
                                        <img
                                            src={img.logos_seducetoken}
                                            alt="logo"
                                            id="logo_js_f"
                                        />
                                    </a>
                                </div>

                                <div>
                                    <ul className="footer__social space-x-10 mb-40">
                                        <li>
                                            <a href="https://instagram.com/seduce_token_official?utm_medium=copy_link">
                                                <i className="ri-instagram-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/seducetokenbsc">
                                                <i className="ri-twitter-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://discord.gg/ewekBsfU4B">
                                                <i className="ri-discord-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://t.me/seducetokenofficial">
                                                <i className="ri-telegram-line"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Project</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/"> Home </a>
                                    </li>
                                    <li>
                                        <a href="/about">About us</a>
                                    </li>
                                    <li>
                                        <a href="/team"> Our Team</a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/ambassador">Ambassadors</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Get help</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/contact">Contact Us</a>
                                    </li>
                                    <li>
                                        <a href="/dashboard" target="_blank">
                                            Buy Token
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Documents</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a
                                            href={img.whitepaper}
                                            // target="_blank"
                                            rel="noreferrer"
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p className="copyright text-center">
                            © Seduce Token 2021. Created with love by
                            <a
                                href="https://theclusterco.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                TheCluster
                            </a>
                            .
                        </p>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default Ambassador
